module.exports = __webpack_public_path__ + "assets/img/supportAn.2b22f182.png";